import { useEffect } from "react";

const SITE = "Tijiya Exports";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export function useSeo(title, description, jsonLd) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    const t = title ? `${title} | ${SITE}` : `${SITE} — Fence Fittings, Foundation Bolts & Construction Hardware`;
    document.title = t;
    const d = description || "Kolkata manufacturer and exporter of fence fittings, foundation bolts, construction stakes, washers, cut rebars and threaded rods since 1987.";
    setMeta("name", "description", d);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:image", `${window.location.origin}/img/factory.jpg`);
    let s = document.getElementById("page-ld");
    if (s) s.remove();
    if (ld) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "page-ld";
      s.textContent = ld;
      document.head.appendChild(s);
    }
  }, [title, description, ld]);
}

export function track(event, params = {}) {
  try { if (window.gtag) window.gtag("event", event, params); } catch { /* analytics unavailable */ }
}

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org", "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${window.location.origin}${path}` })),
});
